import { render, staticRenderFns } from "./ProformaInvoiceIndex.vue?vue&type=template&id=27223cba"
import script from "./ProformaInvoiceIndex.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./ProformaInvoiceIndex.vue?vue&type=style&index=0&id=27223cba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports